import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import LinearProgress from '@mui/material/LinearProgress';
import { AppHeader } from './components/AppHeader';
import { AppFooter } from './components/AppFooter';

const HomePage = lazy(() => import('./pages/HomePage').then((m) => ({ default: m.HomePage })));
const AuthenticationPage = lazy(() => import('./pages/AuthenticationPage').then((m) => ({ default: m.AuthenticationPage })));
const ResourcePage = lazy(() => import('./pages/ResourcePage').then((m) => ({ default: m.ResourcePage })));
const EndpointPage = lazy(() => import('./pages/EndpointPage').then((m) => ({ default: m.EndpointPage })));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage').then((m) => ({ default: m.NotFoundPage })));

export function App(): JSX.Element {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppHeader />
      <Container component="main" maxWidth="lg" sx={{ flex: 1, py: { xs: 4, md: 6 } }}>
        <Suspense fallback={<LinearProgress sx={{ mt: 2 }} />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/authentication" element={<AuthenticationPage />} />
            <Route path="/:resourceSlug" element={<ResourcePage />} />
            <Route path="/:resourceSlug/:endpointSlug" element={<EndpointPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </Container>
      <AppFooter />
    </Box>
  );
}
